export default {"src":"/_next/static/media/NVDA.4a48a649.svg","height":18,"width":18};